import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/activeClientsSagas";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";

const MembershipTypes = () => {
  const dispatch = useDispatch();
  const options = useSelector((state) => state.activeClients.filters.membership_types);
  const selectedOption = useSelector(
    (state) => state.activeClients.selectedFilters.membership_types
  );

  return (
    <div className="select-box-no-width">
      <p>Membership Types</p>
      <MultiSelectDropdown
        options={options}
        selectedFilters={selectedOption}
        height="350px"
        numberDisplayed={0}
        enableOnly
        includeSelectAll
        onSelectChange={(newValue) => dispatch(actionCreators.updateMembershipType(newValue))}
      />
    </div>
  );
};

export default MembershipTypes;
